// extracted by mini-css-extract-plugin
export default {"content":"style_content__2tngr","profileCard":"style_profileCard__gFRnJ"};